import { CareerModulePermissions } from '../../careers/types/career-module-permissions.model';

export class AppPermission {
    career: CareerModulePermissions;
}